const COLOR_MAP = {
    WHITE: '#FFFFFF',
    BLACK: '#000000',
    RED: '#DC143C',
    BLUE: '#4169E1',
    GREEN: '#228B22',
    YELLOW: '#FFD700',
    ORANGE: '#FF8C00',
    PURPLE: '#9370DB',
    PINK: '#FF69B4',
    BROWN: '#8B4513',
    GRAY: '#808080',
    GREY: '#808080',
    SILVER: '#C0C0C0',
    GOLD: '#FFD700'
};
export function getHexColor(colorName) {
    const upperColorName = colorName.toUpperCase().trim();
    if (upperColorName.startsWith('#')) {
        return upperColorName;
    }
    for (const [name, hex] of Object.entries(COLOR_MAP)) {
        if (upperColorName.includes(name)) {
            return hex;
        }
    }
    return '#CCCCCC';
}
